import {
  ActionReducerMapBuilder,
  EntityState,
  createAsyncThunk,
} from '@reduxjs/toolkit';
import { classToPlain } from 'class-transformer';

import { AppError } from '@vk-hr-tek/core/error';

import { ThunkExtra } from '@app/store';
import {
  DashboardService,
  GetAccountWidgetBannerResponse,
  GetUserWidgetBannerParams,
} from '@app/gen/dashboard';
import { DynamicEntity } from '@app/types';

import { DashboardState } from '../../dashboard.state';

export const getWidgetBanner = createAsyncThunk<
  GetAccountWidgetBannerResponse,
  GetUserWidgetBannerParams,
  ThunkExtra
>(
  'widgets/getWidgetBanner',
  async (widgetParams, { rejectWithValue, extra: { inject } }) => {
    try {
      const service = inject(DashboardService);

      const result = await service.getUserWidgetBanner({
        params: widgetParams,
      });

      return result;
    } catch (err) {
      return rejectWithValue(classToPlain(err) as AppError);
    }
  },
);

export const bannerReducers = (
  builder: ActionReducerMapBuilder<
    EntityState<DynamicEntity, string> & DashboardState
  >,
) => {
  builder.addCase(getWidgetBanner.pending, (state, action) => {
    const { widget_id: widgetId } = action.meta.arg;
    state.banner[widgetId] = {
      ...state.banner[widgetId],
      status: 'loading',
    };
  });
  builder.addCase(getWidgetBanner.fulfilled, (state, action) => {
    const { widget_id: widgetId } = action.meta.arg;
    state.banner[widgetId] = {
      ...state.banner[widgetId],
      status: 'complete',
      ...action.payload,
    };
  });
  builder.addCase(getWidgetBanner.rejected, (state, action) => {
    const { widget_id: widgetId } = action.meta.arg;
    state.banner[widgetId] = {
      ...state.banner[widgetId],
      status: 'failed',
    };
  });
};
